import { SVGProps, Ref, forwardRef, memo } from 'react';

const SvgComponent = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg width={20} height={19} fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
    <path
      d="M8.28867 2.19833C8.96231 0.634983 11.2199 0.584301 11.8968 2.14635C12.3655 3.2279 12.7231 4.34163 13.0833 5.79684C14.675 5.78128 15.9193 5.81427 17.1751 5.92247C18.9407 6.07459 19.6532 8.13287 18.2787 9.20609C17.5018 9.81271 16.6676 10.3738 15.6219 11.003C15.3275 11.1801 15.1951 11.5266 15.3019 11.8437C15.7898 13.2944 16.1194 14.4719 16.3758 15.7074C16.717 17.3502 14.9117 18.6037 13.4445 17.694C12.3195 16.9966 11.2976 16.1938 10.0399 15.0486C8.79365 16.1486 7.77677 16.9291 6.66476 17.6221C5.18905 18.542 3.34494 17.302 3.68755 15.6467C3.93518 14.4503 4.26533 13.2866 4.76778 11.8505C4.87973 11.5305 4.74728 11.1779 4.44859 10.9993C3.37112 10.3549 2.5154 9.78095 1.71256 9.14839C0.360206 8.08285 1.0506 6.05189 2.79363 5.89748C4.0693 5.78445 5.34306 5.76049 6.99662 5.79684C7.43202 4.37696 7.82291 3.27921 8.28867 2.19833Z"
      fill={props?.fill || 'white'}
      stroke={props?.stroke || '#070F21'}
      strokeLinejoin="round"
    />
  </svg>
);

const ForwardRef = forwardRef(SvgComponent);
const Star = memo(ForwardRef);
export default Star;
